<style src="./Home.scss" lang="scss" scoped></style>
<template>
  <section class="home">
    <section v-if="!qsCpf && !showRoom" class="columns">
      <!-- ESQUERDA -->
      <div class="left" @keydown="handleEnterKey">
        <!-- FORM LOGIN -->
        <div class="form">
          <div class="title">Bem-vindo</div>
          <div class="title">à <span class="two">TeleConsulta</span></div>

          <div class="title-two">Digite o seu CPF para entrar</div>

          <div class="subtitle">CPF</div>
          <div class="box-input">
            <InputText
              placeholder="Digite aqui o seu CPF"
              mask="###.###.###-##"
              v-model="inputCpf"
            />
          </div>

          <div class="act">
            <div class="btn" @click="actOpenRoom">Entrar</div>
          </div>
        </div>
      </div>
      <!-- DIREITA -->
      <div class="right">
        <Carousel />
      </div>
    </section>

    <!-- VIDEOCONFERENCIA -->
    <section v-if="showRoom" class="videoconferencia">
      <Video :cpf="inputCpf" @close="onCloseRoom" :startRoom="startRoom"/>
    </section>
    <!-- *** -->
  </section>
</template>

<script>
import Firebase from '@/helpers/firebase'
import Carousel from './components/Carousel'

import InputText from '@/components/input/text/InputText'
import Video from '@/views/video/Video'

export default {
  name: 'PortaVideoHome',
  components: {
    InputText,
    Video,
    Carousel
  },

  data () {
    return {
      inputCpf: null,

      showRoom: false,
      startRoom: false,
      qsCpf: false
    }
  },

  mounted () {
    // const qs = this.$route.query
    // qs.env ? Firebase.setFirebaseConfig(qs.env) : Firebase.setFirebaseConfig(null)
    // if (!qs.id) {
    //   console.warn('QueryString ID não identificado')
    // } else {
    //   this.qsCpf = true
    //   const id = this.$route.query.id
    //   Firebase.onCallRoom(id, (obj) => {
    //     if (!obj) {
    //       return
    //     }
    //     if (obj.cpf && !this.showRoom) {
    //       this.inputCpf = obj.cpf
    //       this.showRoom = true
    //       setTimeout(()=> {
    //         this.startRoom = true
    //       }, 250)
    //     }
    //   })
    // }
  },

  methods: {
    /**
     * Detecta a tecla "Enter" e chama o método `actOpenRoom` se pressionada.
     * @param {KeyboardEvent} event - O evento de teclado que foi disparado.
     */
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.actOpenRoom()
      }
    },

    actOpenRoom () {
      if (!this.validateCpf()) {
        return
      }
      this.showRoom = true
      setTimeout(()=> {
        this.startRoom = true
      }, 250)
    },
    onCloseRoom () {
      this.showRoom = false
      this.startRoom = false
      this.inputCpf = null
    },

    validateCpf () {
      if(!this.inputCpf) {
        return false
      }
      if(this.inputCpf.length < 14) {
        return false
      }
      return true
    }
  }
}
</script>
